<template>
  <div class="form user-form user-forget-password">
    <h2>{{$t('忘记密码')}}</h2>
    <div class="form-field field-account">
      <div class="addion">
        <i class="fa fa-user"></i>
      </div>
      <input v-model="account" type="text" :placeholder="$t('请输入已有账号')">
    </div>
    <div class="form-field field-code">
      <div class="addion">
        <i class="fa fa-shield"></i>
      </div>
      <input v-model="code" type="password" :placeholder="$t('填写验证码')" />
      <div class="addion">
        <SubmitButton class="button" :submit="handleGetCode" :valid="!disabledCodeButton" :errors.sync="errors">
          <span v-show="!codeTimeleftLabel">{{ $t('获取验证码') }}</span>
          <span v-show="codeTimeleftLabel">{{codeTimeleftLabel}}</span>
        </SubmitButton>
      </div>
    </div>
    <div class="form-field field-password">
      <div class="addion">
        <i class="fa fa-lock"></i>
      </div>
      <input v-model="password" type="password" :placeholder="$t('请输入密码')" />
    </div>
    <div class="form-field field-confirmPassword">
      <div class="addion">
        <i class="fa fa-lock"></i>
      </div>
      <input v-model="confirmPassword" type="password" :placeholder="$t('确认密码')" />
    </div>
    <div class="text-error" v-show="errors" v-for="(error, key) in errors" :key="key">* {{error}}</div>
    <div class="actions">
      <SubmitButton class="btn btn-next" :valid="valid" :submit="handleSubmit" :errors.sync="errors">{{$t('提交')}}</SubmitButton>
    </div>
    <div class="footer flex-row">
      <div class="flex1"></div>
      <div class="text-primary" @click="$emit('dest', 'login')">{{$t('登录')}}</div>
    </div>
  </div>
</template>

<script>
import apiUser from "@/api/user";
import SubmitButton from '../SubmitButton'

export default {
  name: "ForgetPassword",
  components: { SubmitButton },
  data() {
    return {
      account: "",
      code: "",
      password: "",
      confirmPassword: "",
      codeTimeleftLabel: "",
      lastCodeTime: null,
      codeDisabled: false,
      timerId: null,
      errors: [],
    };
  },
  computed: {
    valid() {
      return (
        this.account &&
        this.code &&
        this.password &&
        this.confirmPassword &&
        this.password === this.confirmPassword
      );
    },
    disabledCodeButton() {
      return this.codeDisabled || !this.account;
    },
  },
  beforeDestroy() {
    this.timerId || clearInterval(this.timerId);
  },
  methods: {
    handleGetCode() {
      //60秒内只能发送一次验证码
      let time = Number.parseInt(new Date().getTime() / 1e3);
      if (this.lastCodeTime && this.lastCodeTime + 60 >= time) {
        return;
      }
      let seconds = 60;
      this.codeDisabled = true;
      this.codeTimeleftLabel = seconds + "s";
      this.timerId = setInterval(() => {
        if (--seconds < 1) {
          this.codeDisabled = false;
          this.codeTimeleftLabel = "";
          clearInterval(this.timerId);
        } else {
          this.codeTimeleftLabel = seconds + "s";
        }
      }, 1e3);
      this.lastCodeTime = time;
      return apiUser.getCode({
        intl: this.intl,
        account: this.account,
        type: '2'
      });
    },
    getFormData() {
      return {
        account: this.account,
        code: this.code,
        password: this.password,
        confirmPassword: this.confirmPassword,
      };
    },
    handleSubmit() {
      let data = this.getFormData()
      return apiUser.resetPassword(data).then(res => {
        this.$emit('forget', res)
      })
    }
  },
};
</script>